import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';
import { GO_MODAL_DATA } from '@go-modules/services/go-modal/go-modal.tokens';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'session-status-dialog',
	templateUrl: './session-status-dialog.component.html',
	styleUrls: ['./session-status-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		TranslateModule,
		A11yModule,
		GoDialogContentDirective
	]
})
export class SessionStatusDialogComponent {
	public dialogTitleId = `session-status-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	constructor (
		public dialogRef: GoDialogRef,
		@Inject(GO_MODAL_DATA) public data: {
			message: string;
		}
	) {}
}
